/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { JobAttributes } from '../models/JobAttributes';
import type { Pick_TemplateAIAttributes_id_or_name_ } from '../models/Pick_TemplateAIAttributes_id_or_name_';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class TemplaterService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @param requestBody
     * @param useDevFile
     * @param hiddenTabs
     * @param deletedTabs
     * @returns string Ok
     * @throws ApiError
     */
    public fillExcel(
        requestBody: any,
        useDevFile: boolean = false,
        hiddenTabs?: string,
        deletedTabs?: string,
    ): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/templater/excel',
            query: {
                'useDevFile': useDevFile,
                'hiddenTabs': hiddenTabs,
                'deletedTabs': deletedTabs,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns string Ok
     * @throws ApiError
     */
    public runQuery(
        requestBody: {
            query: string;
            data: string;
        },
    ): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/templater/test',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns Pick_TemplateAIAttributes_id_or_name_ Ok
     * @throws ApiError
     */
    public listReportTemplates(): CancelablePromise<Array<Pick_TemplateAIAttributes_id_or_name_>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/templater/report/templates',
        });
    }
    /**
     * Retrieve a report template in the database, compute the Excel file, feed it to our LLM with the  template and the data, and return the result as html (rich text).
     * @param templateId - The id of the template, stored in the database
     * @param requestBody - The body of the report
     * @param useDevFile
     * @param hiddenTabs
     * @param deletedTabs
     * @returns string The report
     * @throws ApiError
     */
    public generateReport(
        templateId: number,
        requestBody: any,
        useDevFile: boolean = false,
        hiddenTabs?: string,
        deletedTabs?: string,
    ): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/templater/report/{templateId}',
            path: {
                'templateId': templateId,
            },
            query: {
                'useDevFile': useDevFile,
                'hiddenTabs': hiddenTabs,
                'deletedTabs': deletedTabs,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Passes the request to generate a report template for later execution.
     * @param templateId - The id of the template, stored in the database
     * @param requestBody - The body of the report
     * @returns JobAttributes
     * @throws ApiError
     */
    public generateReportAsync(
        templateId: number,
        requestBody: any,
    ): CancelablePromise<JobAttributes> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/templater/report/{templateId}/async',
            path: {
                'templateId': templateId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
